
$(document).ready(function () {

  $('body').on('click', '.moduleSportAccordionHeader', function (e) {
    if ($(e.currentTarget) && $(e.currentTarget).parent()) {
      let actualGroupHeight = $(e.currentTarget).parent().height();
      $(e.currentTarget).parent().css({
        'height': actualGroupHeight + 'px'
      });
    }


    setTimeout(function () {
      if ($(e.currentTarget).parent().hasClass('hideSportGroup')) {
        $(e.currentTarget).parent().removeClass('hideSportGroup');
        let groupHeight = $(e.currentTarget).height() + $(e.currentTarget).siblings('.moduleSportAccordionContent').height();
        $(e.currentTarget).parent().css({
          'height': groupHeight + 'px'
        });
      } else {
        $(e.currentTarget).parent().addClass('hideSportGroup');
        $(e.currentTarget).parent().css({
          'height': 25 + 'px'
        });
      }
    }, 100);

  });

  $('body').on('click', '.moduleSportSingleLeagueHeader', function (e) {
    $(e.currentTarget).parent().parent().parent().parent().css({
      'height': 'auto'
    });
    if ($(e.currentTarget).parent().hasClass('hideGroup')) {
      $(e.currentTarget).parent().removeClass('hideGroup');
    } else {
      $(e.currentTarget).parent().addClass('hideGroup');
    }
  });

  $('body').on('click', '.moduleSportSingleLeagueAccordionEvent', function (e) {
    $(e.currentTarget).parent().parent().parent().parent().parent().parent().parent().css({
      'height': 'auto'
    });
    if ($(e.currentTarget).parent().parent().hasClass('hideDetails')) {
      $(e.currentTarget).parent().parent().removeClass('hideDetails');
    } else {
      $(e.currentTarget).parent().parent().addClass('hideDetails');
    }
  });


  // $('body').on('click', '.betHomeButton', function(e){
  //   if($(e.currentTarget).hasClass('betSlipAdded')){
  //     $(e.currentTarget).removeClass('betSlipAdded');
  //   }else {
  //     $(e.currentTarget).addClass('betSlipAdded');
  //     let betButtonName = $(e.currentTarget).children('span:first').text();
  //     let betButtonValue = $(e.currentTarget).children('span:last').text();
  //   }
  // });
  //
  // $('body').on('click', '.betDrawButton', function(e){
  //   if($(e.currentTarget).hasClass('betSlipAdded')){
  //     $(e.currentTarget).removeClass('betSlipAdded');
  //   }else {
  //     $(e.currentTarget).addClass('betSlipAdded');
  //     let betButtonName = $(e.currentTarget).children('span:first').text();
  //     let betButtonValue = $(e.currentTarget).children('span:last').text();
  //   }
  // });
  //
  // $('body').on('click', '.betAwayButton', function(e){
  //   if($(e.currentTarget).hasClass('betSlipAdded')){
  //     $(e.currentTarget).removeClass('betSlipAdded');
  //   }else {
  //     $(e.currentTarget).addClass('betSlipAdded');
  //     let betButtonName = $(e.currentTarget).children('span:first').text();
  //     let betButtonValue = $(e.currentTarget).children('span:last').text();
  //   }
  // });

  $('body').on('click', '.moduleSportSingleLeagueMatchLink', function (e) {
    let singleMatchName = $(e.currentTarget).children('span:first').text();
  });




});
